import { render, staticRenderFns } from "./PaymentView.vue?vue&type=template&id=738b210b&scoped=true&lang=pug"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"
import style0 from "./PaymentView.vue?vue&type=style&index=0&id=738b210b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b210b",
  null
  
)

export default component.exports